// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2_j2f","unreadBadge":"styles_unreadBadge__3awr1","modalContent":"styles_modalContent__u4M25","modal":"styles_modal__2-nBx"};